import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { triggerStateChangedRequest, b64toBlob, stopCloneStamp } from '~core';
import { onErrorShowMessage } from '~src/errors';
import { changeImageSrc, cleanBase64 } from '~src/utils';
import {
  handleTabAttachments,
  displaySidebarAttachments,
  fetchEditorAttachments,
} from '~src/sidebarLegacy';
import { getState } from '~src/state';

export const handleCloneStampApply = async (imgBase64) => {
  const attachmentsUploader = getState('uploader.allegati');

  Swal.fire({
    text: 'Sto salvando la foto ritoccata tra gli allegati',
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const filename = `cloneStamped-${uuidv4()}.png`;
    const blob = b64toBlob(cleanBase64(imgBase64).base64, 'image/png'); // todo: double check mime type

    attachmentsUploader.addFile({
      name: filename,
      type: blob.type,
      data: blob,
    });

    const response = await attachmentsUploader.upload();

    attachmentsUploader.cancelAll();

    const url = `${process.env.EDGE_RESIZER}${
      new URL(response.successful[0].uploadURL).pathname
    }`;

    // const originalWidth =
    //   window.canvas.getActiveObject().width *
    //   window.canvas.getActiveObject().scaleX;
    // const originalHeight =
    //   window.canvas.getActiveObject().height *
    //   window.canvas.getActiveObject().scaleY;

    // const url = `${process.env.EDGE_RESIZER}${
    //   new URL(response.successful[0].uploadURL).pathname
    // }?w=${originalWidth}&h=${originalHeight}`;

    await changeImageSrc(window.canvas.getActiveObject(), url);
    // window.canvas.getActiveObject().set({

    // })
    window.canvas.requestRenderAll();
    triggerStateChangedRequest();

    const { attachments } = await fetchEditorAttachments(true);
    window.editorConfig.sidebarAttachments = attachments;
    displaySidebarAttachments();
    handleTabAttachments();
    Swal.close();
    stopCloneStamp();
  } catch (err) {
    console.error(err);
    onErrorShowMessage();
  }
};
